import React from "react";
import "../ProjectPage/ProjectPage.scss";

import ZoomImage from "../../components/ZoomImage";
import VideoHeader from "../../components/VideoHeader/VideoHeader";
import VideoComp from "../../components/VideoComp/VideoComp";
import GridCards from "../../components/GridCards/GridCards";
import Carousel from "../../components/Carousel"

function ProjectPage(props) {
  window.scrollTo(0, 0);
  return (
    <div>
      <VideoHeader
        videoHeader={props.videoHeader}
        imgSrc={props.imgSrc}
        videoSrc={props.videoSrc}
        headerText={props.headerText}
      />

      {props.imgZoom.zoomImg && <ZoomImage imgZoom={props.imgZoom} />}
      {console.log("Proops", props)}
      {/* <div>{props.glitch != null && <P5Canvas />}</div> */}
      {props.chapters.length > 0 && (
        <div>

          {props.chapters.map((image) => {
            console.log(Object.values(image)[0]);

            return (
              <div style={{ backgroundColor: Object.values(image)[0].color }}>
                <div
                  className="container-body chapter-title"
                  style={{ color: Object.values(image)[0].textColor }}
                >
                  <div className="chapter">
                    {Object.values(image)[0].type === "image" ||
                      Object.values(image)[0].type == null ? (
                        <div
                          className={
                            Object.values(image)[0].text != null
                              ? "two-column-img "
                              : "one-column-img"
                          }
                        >
                          {Object.values(image)[0].Chaptertitle != null && (
                            <h3 className="chapter-title">
                              {Object.values(image)[0].Chaptertitle}
                              {console.log("type", Object.values(image)[0].url)}
                            </h3>
                          )}
                          <img
                            style={{ width: "100%" }}
                            src={Object.values(image)[0].url}
                            alt={Object.keys(image)[0]}
                          ></img>
                          <p className="img-subtitle">
                            <i>{Object.keys(image)[0]}</i>
                          </p>
                        </div>
                      ) : (
                        <VideoComp
                          muted={true}
                          video={Object.values(image)[0].url}
                        />
                      )}
                    {Object.values(image)[0].text != null && (
                      <div class="text-row">
                        {Object.values(image)[0].title != null && (
                          <h3 className="img-Title">
                            {Object.values(image)[0].title}
                          </h3>
                        )}

                        <p>{Object.values(image)[0].text}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {props.videos != null && (
        <div>
          {props.videos.map((videod) => {
            console.log(videod);
            return <VideoComp video={videod} />;
          })}
        </div>
      )}
      {console.log("eitheror", props.headerText.eitheror)}
      {props.headerText.eitheror === true && <GridCards />}
      <Carousel defaultClicks={3} />
    </div>
  );
}

export default ProjectPage;
